import { type ChartsData } from 'legacy/components/DataViz/dataViz.types'

type CsvArrayRows = (string | number | null)[][]
type ChartsDataByChart = { [key: string]: ChartsData }

export function generateChartsHeaders(chartsData: ChartsDataByChart): string[] {
  const headers = ['series', 'date', 'value']

  if (Object.keys(chartsData).length > 1) {
    headers.unshift('dataset')
    return headers
  }

  return headers
}

export function generateChartsRows(chartsData: ChartsDataByChart): CsvArrayRows {
  const dataSets = Object.keys(chartsData)
  const multipleSets = dataSets.length > 1
  const rows: CsvArrayRows = []

  dataSets.forEach(setName => {
    const { series } = chartsData[setName]
    const { data } = chartsData[setName]

    data.forEach((dataPoints, dataIndex) => {
      const { label } = series[dataIndex]

      dataPoints.forEach(dataPoint => {
        const date = dataPoint.x
        const value = dataPoint.y

        if (multipleSets) {
          rows.push([setName, label, date, value])
          return
        }

        return rows.push([label, date, value])
      })
    })
  })

  return rows
}

export function joinChartsRows(headers: string[], rows: CsvArrayRows): string {
  const fieldDelimiter = ','
  const rowDelimiter = '\n'

  return [headers, ...rows].map(row => row.join(fieldDelimiter)).join(rowDelimiter)
}

export function chartsToCsv(chartsData: ChartsDataByChart): string {
  return joinChartsRows(generateChartsHeaders(chartsData), generateChartsRows(chartsData))
}

export function generateCsvUri(csvString: string) {
  const encodingString = 'data:text/csv;charset=utf-8,'
  const csvStringWithEncoding = `${encodingString}${csvString}`

  return encodeURI(csvStringWithEncoding)
}
